import {Component, Signal} from '@angular/core';
import {HeaderComponent} from '../header/header.component';
import {FooterComponent} from '../footer/footer.component';
import {NgStyle} from "@angular/common";
import {Store} from "@ngrx/store";
import {selectUISettings} from "../../store/selectors/app.selectors";
import {UISettings} from "../../services/ssession.service";

@Component({
  selector: 'app-content',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgStyle
  ],
  templateUrl: './content.component.html'
})
export class ContentComponent {

  public uiSettings: Signal<UISettings | null> = this.store$.selectSignal(selectUISettings);

  constructor(private store$: Store) {
  }
}
